var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00125 17C10.5834 16.9998 12.1299 16.5304 13.4453 15.6512C14.7607 14.7721 15.7859 13.5226 16.3913 12.0609C16.9966 10.5991 17.1549 8.9907 16.8462 7.43897C16.5375 5.88724 15.7756 4.46189 14.6569 3.34315C13.5381 2.2244 12.1128 1.4625 10.561 1.15378C9.0093 0.845061 7.40087 1.00338 5.93911 1.60873C4.47735 2.21407 3.22791 3.23926 2.34877 4.55466C1.46962 5.87006 1.00025 7.4166 1 8.99875C0.999835 10.0495 1.20668 11.0901 1.60872 12.0609C2.01077 13.0317 2.60013 13.9138 3.34315 14.6569C4.08616 15.3999 4.96828 15.9892 5.93911 16.3913C6.90994 16.7933 7.95047 17.0002 9.00125 17V17Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40103 11.5078H16.372",
    stroke: "#5E5E5E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40103 6.4895H16.372",
    stroke: "#5E5E5E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2745 1.1875C5.83862 6.36828 6.05001 11.8674 7.87936 16.9227",
    stroke: "#5E5E5E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7257 1.1875C11.3529 3.44213 11.6696 5.7718 11.6669 8.11205C11.6732 11.1161 11.1534 14.098 10.1309 16.9227",
    stroke: "#5E5E5E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSiteIcon);
export default __webpack_public_path__ + "static/media/WebSiteIcon.3aef4b5355c283226d959aec1a037838.svg";
export { ForwardRef as ReactComponent };